import { useEffect, useState } from "react";

function useDirections() {
  const [routeData, setRouteData] = useState({})
  const [directions, setDirections] = useState({})

  const findDirections = (lat, lng, dest) => {
    if (!dest || dest.length == 0) {
      console.log("invalid dest")
    };
    fetch(`https://us-west1-dubmaps.cloudfunctions.net/findRoute?lat=${lat}&lng=${lng}&dest=${dest}`)
            .then(response => {
                if (response.ok)
                  response.json().then(json => {
                      setRouteData(json)
                  })
                else
                  console.log(`${response.status} ${response.statusText}`)
            })
  }

  useEffect(() => {
    // Find directions from route data
    // routeData.routes[i].legs[j].steps[k]

    let directions = [];

    try {
      for (let i = 0; i < routeData.routes.length; i++) {
        for (let j = 0; j < routeData.routes[i].legs.length; j++) {
          for (let k = 0; k < routeData.routes[i].legs[j].steps.length; k++) {
            let route = routeData.routes[i].legs[j].steps[k]
            directions.push(route);
          }
        }
      }
    } catch (error) {
      console.log("Parsing route data failed")
    }

    setDirections(directions)
  }, [routeData])

  return [directions, findDirections]
}

export default useDirections;